import React, {useEffect} from "react";
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import styles from "./styles/Home.module.css";
import { IoIosPricetag } from "react-icons/io";
import { IoMdSearch } from "react-icons/io";
import { GiBuyCard } from "react-icons/gi";
import { MdOutlineMessage } from "react-icons/md";
import { FaTools } from "react-icons/fa";
import Carrusel from "./component/Carrusel";
import CarruselUser from "./component/CarruselUser";
import {Link} from 'react-router-dom';


import img1 from '../resources/images/slide1.PNG'
import img2 from '../resources/images/slide2.PNG'

import $ from "jquery";  

const imagenes = [img1, img2];

const Home = () => {
    
useEffect(() => {
    $(".titleContainer h1").hide().fadeIn(800);
    return () => {
      $(".titleContainer h1").stop(true, true).show();
    };
}, []);


const datosImagenes = [
  {
    pos: { top: "31%", left: "26%", width: "650px", height: "125px" },
    title: "Una experiencia de aprendizaje enriquecedora",
    lines: [
      "Desarrolla competencias claves para el hoy y el mañana. Comienza tu camino con nosotros",
      "Tu viaje empieza aquí",
    ],
    noPointer: true 
  },

  {
    pos: { top: "5%", left: "15%", width: "1091px", height: "100px" },
    title: "Habilidades que impulsan tu crecimiento",
    lines: [
      "El entorno tecnológico y laboral cambia constantemente, pero con nosotros podrás adaptarte y progresar.",
      "Adquiere las competencias que necesitas para alcanzar tus metas y mantenerte competitivo"
    ],
    noPointer: true
  }
];


    return(
        <>
        <div name="Home" className={styles.home}> 
            <div className={styles.titleContainer}>
                <h2>Todas las habilidades y conocimientos que necesitas en un único lugar.</h2>
                <h3>Aprende habilidades esenciales o temas técnicos, respaldamos tu desarrollo académico</h3>
                    <div className={styles.carruselImagen}>
                        <Swiper
                            modules={[Navigation]}
                            slidesPerView={1}
                            loop={true}
                            navigation={true}
                            className={styles.swiperContainer}
                        >
                            {imagenes?.map((src, index) => {
                                const datoImagen = datosImagenes[index];
                                return (
                                    <SwiperSlide key={index} className={styles.slideWrapper}>
                                        <img src={src} alt={`slide-${index}`} className={styles.slideImage} />

                                        {datoImagen && (
                                            <div className={`${styles.overlay} ${datoImagen.noPointer ? styles.noPointer : ""}`} style={datoImagen.pos}>
                                                <div className={styles.overlayContent}>
                                                    <h3>{datoImagen.title}</h3>
                                                    {datoImagen.lines.map((text, i) => (
                                                        <p key={i}>{text}</p>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </SwiperSlide>
                                );
                            })}     
                        </Swiper>
                    </div>
                <h2>¿Listo para comenzar? Elige tu cuenta</h2>
                <h3>Monetiza tus conocimientos con una cuenta de tutor o aprende con una cuenta de cliente</h3>
                <br/>
                <h3>Elige tu tipo de cuenta</h3>
                <div className={styles.ctaContainer}>  
                    <div className={styles.row}>
                        <div className={styles.left}>
                            <h4 className={styles.calltoAction}>Cliente</h4>
                            <ul style={{listStyle: 'none', paddingTop: '15px'}}>
                                <li><IoIosPricetag /> Cuenta gratuita</li>
                                <li><IoMdSearch /> Explora el contenido de los tutores registrados en la web</li>
                                <li><GiBuyCard /> Compra el contenido o inscribete a las clases que más se adecuen a tus necesidades</li>
                                <li><MdOutlineMessage /> Comunicate con los tutores en caso de duda, escribe y lee reseñas en contenido</li>
                            </ul>
                        </div>
                        <div className={styles.right}>
                            <h4 className={styles.calltoAction}>Tutor</h4>
                            <ul style={{listStyle: 'none', paddingTop: '15px'}}>
                                <li><GiBuyCard /> Empieza a vender tus conocimientos y habilidades y crea un negocio rentable</li>
                                <li><IoIosPricetag /> Primer mes gratuito y puedes cancelar cuando desees</li>
                                <li><FaTools /> Todas las herramientas necesarias para monetizar tu contenido</li>
                            </ul>
                            <h4 style={{ paddingTop: '55px' }}><IoIosPricetag /> Crea tu cuenta de tutor por <strong>4,99€</strong>/mes</h4>
                        </div>
                    </div>
                    <button><Link to="/register" style={{color: 'var(--textButtonHome)'}}>Registrate aquí</Link></button>
                </div>
            </div>
        </div>
            <Carrusel />
            <CarruselUser />

        </>
        
    );
};

export default Home;


